<template>
  <div class="page flex-col ">
    <LoginButton />
    <div class="scaler" style="padding-top:15vh;">
      <span class="text_1">请选择您的出镜效果</span>
      <div class="group_1 flex-row justify-between ">
        <div class="group_2 flex-col">
          <div class="group_3 flex-col" id="interview_pre_video" style="overflow:hidden;">
            <img v-if="cameraAccess == 'denied'" class="image_1" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG7299e06472f6ba6e89deac96771f2e41.png" />
            <span v-if="cameraAccess == 'denied'" class="text_2">摄像头画面未授权</span>
            <VERTCVideo ref="vertcVideo" :whiteIntensity="beautifys[2].slideValue * 0.01"
              :smoothIntensity="beautifys[1].slideValue * 0.01" :sharpenIntensity="beautifys[3].slideValue * 0.01"
              :filterIntensity="usingFilter ? usingFilter.slideValue * 0.01 : 0"
              :filterType="usingFilter ? usingFilter.name : '不使用'" refName="interview_pre_video"
              :closeVideoTransfer="true" :closeAudioTransfer="true" @ffmpegStartDownloading="ffmpegStartDownloading"
              @ffmpegStopDownloading="ffmpegStopDownloading">
            </VERTCVideo>
          </div>
        </div>
        <el-tabs class="group_4" v-model="activeTab" type="border-card" style="margin-top:10px">
          <el-tab-pane label="美颜效果" name="beautify">
            <div class="grid-container" :style="{ '--grid-columns': 5 }">
              <div class="grid-item flex-col justify-end" :class="{ 'clicked': item.clicked }"
                v-for="(item, index) in beautifys" :key="index" @click="item.clickFunc(index)">
                <img class="label_2" referrerpolicy="no-referrer" :src="item.img" />
                <div class="text-wrapper_3 flex-col"><span class="text_6">{{ item.name }}</span></div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="滤镜" name="filter">
            <div class="grid-container" :style="{ '--grid-columns': 5 }">
              <div class="grid-item flex-col justify-end" :class="{ 'clicked': item.clicked }"
                v-for="(item, index) in filters" :key="index" @click="item.clickFunc(index)">
                <img v-if="index == 0" class="label_2" referrerpolicy="no-referrer" :src="item.img" />
                <img v-else style="width:80px;height:60px;border-radius:24px 24px 0px 0px;z-index:-1;"
                  referrerpolicy="no-referrer" :src="item.img" />
                <div v-if="index == 0" class="text-wrapper_3 flex-col"><span class="text_6">{{ item.name }}</span></div>
                <div v-else class="text-wrapper_3 flex-col" style="margin-top:-4px;"><span class="text_6">{{ item.name
                    }}</span></div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="虚拟背景" name="background">
            <div class="grid-container" :style="{ '--grid-columns': 5 }">
              <div class="grid-item flex-col justify-center align-center" :class="{ 'clicked': item.clicked }"
                v-for="(item, index) in backgrounds" :key="index" @click="item.clickFunc(index)">
                <img v-if="index == 0" class="label_2"
                  style="width:50px;height:50px;border-radius:24px;z-index:-1;margin:0px;" referrerpolicy="no-referrer"
                  :src="item.img" />
                <img v-else class="label_2" style="width:80px;height:80px;border-radius:24px;z-index:-1;margin:0px;"
                  referrerpolicy="no-referrer" :src="item.img" />
              </div>
            </div>
          </el-tab-pane>
          <div v-if="selectSlidable" class="sliderLine">
            <span style="width:10%;text-align:center;font-size:large;">{{ slideItem.name }}</span>
            <el-slider v-model="slideItem.slideValue" :min="0" :max="100" :step="1" style="width:70%;"
              :show-tooltip="false"></el-slider>
            <span style="width:10%;text-align:center;font-size:large;">{{ slideItem.slideValue }}</span>
          </div>
        </el-tabs>
      </div>

<!--       <div v-if="generateJsonData" class="generate-json-display">
        <h3>生成的数据预览：</h3>
        <div class="json-content">
          <pre>{{ JSON.stringify(generateJsonData, null, 2) }}</pre>
        </div>
      </div>
      

      <div v-if="generateJsonLoading" class="loading-display">
        <div class="loading-spinner"></div>
        <span>正在生成数据...</span>
      </div> -->

      <div class="group_5 flex-row justify-between">
        <div class="text-wrapper_6 flex-col" @click="startInterview()" style="cursor:pointer;"><span
            class="text_10">开始面试</span></div>
        <router-link to="/store/select_metahuman">
          <div class="text-wrapper_7 flex-col"><span class="text_11">上一步</span></div>
        </router-link>
      </div>
    </div>
    <!-- 自定义弹窗 -->
    <div v-show="(waitForPrompt || ffmpegDownloading || (!isCompleteUserData && generateJsonLoading)) && !showPersonalInfoModal" class="custom-popup">
      <div class="popup-content">
        <img src="./assets/img/viewresume.gif" alt="Loading" class="popup-image" />
        <div class="popup-text">
          简历很优秀哦!
        <br>面试官正在为你准备专属问题，请稍等片刻
        </div>
      </div>
    </div>

    <!-- 个人信息填写弹窗 -->
    <div class="personal-info-modal-container" v-if="showPersonalInfoModal" @click.self="closePersonalInfoModal">
      <!-- 遮罩层 -->
      <div class="personal-info-modal-mask"></div>

      <div class="personal-info-modal-content" @click.stop>
        <!-- 头部 -->
        <div class="personal-info-header">
          <div class="personal-info-title">请填写个人信息</div>
        </div>

        <div class="personal-info-form">
          <div class="form-row">
            <div class="form-column">
              <div class="form-item">
                <label class="form-label">姓名<span class="required">*</span></label>
                <input v-model="personalInfo.real_name" type="text" class="form-input" placeholder="请输入姓名" />
              </div>

              <div class="form-item">
                <label class="form-label">性别<span class="required">*</span></label>
                <select v-model="personalInfo.sex" class="form-select">
                  <option :value="1">男</option>
                  <option :value="0">女</option>
                </select>
              </div>

              <div class="form-item">
                <label class="form-label">年龄<span class="required">*</span></label>
                <input v-model="personalInfo.age" type="number" class="form-input" placeholder="请输入年龄" />
              </div>

              <div class="form-item">
                <label class="form-label">学校<span class="required">*</span></label>
                <input v-model="personalInfo.school" type="text" class="form-input" placeholder="请输入学校名称" />
              </div>

              <div class="form-item">
                <label class="form-label">专业<span class="required">*</span></label>
                <input v-model="personalInfo.major" type="text" class="form-input" placeholder="请输入专业名称" />
              </div>

              <div class="form-item">
                <label class="form-label">学历层次<span class="required">*</span></label>
                <select v-model="personalInfo.education" class="form-select">
                  <option value="">请选择学历层次</option>
                  <option :value="1">初中</option>
                  <option :value="2">高中</option>
                  <option :value="3">大专</option>
                  <option :value="4">本科</option>
                  <option :value="5">硕士</option>
                  <option :value="6">博士</option>
                </select>
              </div>
            </div>

            <!-- 右列 -->
            <div class="form-column">

              <div class="form-item">
                <label class="form-label">证件照<span class="required">*</span></label>
                <div class="photo-upload-container">
                  <div class="photo-upload-area" @click="triggerPhotoUpload">
                    <div class="photo-preview">
                      <img :src="getAvatarUrl()" alt="证件照预览" />
                      <div class="photo-overlay">
                        <button type="button" class="change-photo-btn" @click.stop="triggerPhotoUpload">更换</button>
                        <button type="button" class="remove-photo-btn" @click.stop="removePhoto">删除</button>
                      </div>
                    </div>
                  </div>
                  <input ref="photoInput" type="file" accept="image/jpeg,image/png" @change="handlePhotoUpload" style="display: none;" />
                  <div class="upload-tips">
                    <p class="tips-title">让面试官看看你吧!</p>
                    <p class="tips-desc">请您上传1寸白底证件照,JPG/PNG格式,文件大小不超过2MB</p>
                  </div>
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">求职期望<span class="required">*</span></label>
                <div class="row-compact">
                  <select v-model="personalInfo.job_type" class="form-select">
                    <option value="">求职类型</option>
                    <option 
                      v-for="jobType in jobTypes" 
                      :key="jobType.value" 
                      :value="jobType.value"
                    >
                      {{ jobType.label }}
                    </option>
                  </select>
                  <input 
                    v-model="personalInfo.job_objective" 
                    type="text" 
                    class="form-input" 
                    placeholder="请输入期望职位"
                  />
                  <el-select
                    v-model="personalInfo.desired_city"
                    multiple
                    filterable
                    collapse-tags
                    clearable
                    placeholder="搜索心动城市"
                    class="el-select-flex city-select"
                    popper-class="city-dropdown"
                    @change="handleCityChange"
                  >
                    <el-option label="全国" value="全国" />
                    <el-option-group label="热门城市">
                      <el-option v-for="c in hotCities" :key="c" :label="c" :value="c" />
                    </el-option-group>
                    <el-option-group v-for="(list, letter) in citiesByLetter" :key="letter" :label="letter">
                      <el-option v-for="c in list" :key="c" :label="c" :value="c" />
                    </el-option-group>
                  </el-select>
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">薪资待遇<span class="required">*</span></label>
                <div class="row-compact">
                  <input 
                    v-model="personalInfo.expected_salary_start" 
                    type="text" 
                    class="form-input" 
                    placeholder="最低薪资范围/月"
                  />
                  <span class="dash">—</span>
                  <input 
                    v-model="personalInfo.expected_salary_end" 
                    type="text" 
                    class="form-input" 
                    placeholder="最高薪资范围/月"
                  />
                </div>
              </div>

              <div class="form-item">
                <label class="form-label">电话<span class="required">*</span></label>
                <input v-model="personalInfo.mobile" type="tel" class="form-input" placeholder="请输入手机号码" />
              </div>

              <div class="form-item">
                <label class="form-label">邮箱<span class="required">*</span></label>
                <input v-model="personalInfo.email" type="email" class="form-input" placeholder="请输入邮箱地址" />
              </div>
            </div>
          </div>

          <!-- 按钮区域 -->
          <div class="form-buttons">
            <button class="btn-clear" @click="clearPersonalInfoForm">清空表单</button>
            <button class="btn-submit" @click="submitPersonalInfo">提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VERTCVideo from '@/components/VERTCVideo/index.vue'
import SideBar from '@/components/SideBar/index.vue'
// prompt在Dashboard中后台触发，这里仅等待结果
import { getUserInfo, setInfo } from '@/api/user'
import { lxUploadFile } from '@/api/upload'
import { mapState } from 'vuex'
import { JOB_TYPES } from '@/constants/jobConstants'
import { HOT_CITIES, CITIES_BY_LETTER } from '@/constants/cityConstants'
export default {
  components: {
    VERTCVideo, SideBar
  },
  async mounted() {
    this.usingBackground = this.backgrounds[4],
      setTimeout(() => {
        this.setTabClass()
      }, 1) //el-tabs__item的渲染比mounted稍慢
    const permissionStatus = await navigator.permissions.query({ name: 'camera' })
    this.cameraAccess = permissionStatus.state
    permissionStatus.onchange = () => {
      this.cameraAccess = permissionStatus.state
    }

    // 在此处调取后端接口判断是否需要打开个人信息弹框，而不是直接调大模型接口
    this.isCompleteUserData = false
    const response = await getUserInfo();
    if (response.data.code == 1) {
      const safeUserData = response.data.data || {};
      this.safeUserData = safeUserData
      const isRequired = ['job_objective', 'expected_salary_end', 'expected_salary_start']
      const isMissing = isRequired.some(field => !safeUserData[field])
      if (isMissing) {
        // 若当前未在加载且无现成数据，则触发一次生成接口（刷新场景兜底）
        if (!this.generateJsonLoading && !this.generateJsonData) {
          try { 
            await this.$store.dispatch('interviewState/fetchGenerateJson')
            this.isCompleteUserData = false
            await this.waitForGenerateJsonAndOpenModal();
           } catch(e) {
             // 即使失败也要打开弹框让用户填写信息
             this.isCompleteUserData = false
             this.showPersonalInfoModal = true
             this.loadUserInfoWithGenerateJsonFallback(this.safeUserData);
           }
        } else {
          await this.waitForGenerateJsonAndOpenModal();
        }
      } else {
        this.showPersonalInfoModal = false
        this.isCompleteUserData = true
      }
    }
    
    // 等待getGenerateJson接口响应后再检查是否需要打开个人信息弹窗
  },
  computed: {
    ...mapState('interviewState', [
      'generateJsonData',
      'generateJsonLoading',
      'prompt',
      'interviewId',
      'promptLoading',
      'promptError'
    ])
  },
  updated() {
    this.setTabClass()
  },
  data() {
    return {
      ffmpegDownloading: false,
      waitForPrompt: false,
      cameraAccess: 'denied',
      selectSlidable: false,
      slideItem: null,
      activeTab: 'beautify',
      usingBeautifys: [],
      // 个人信息弹窗相关数据
      showPersonalInfoModal: false,
      personalInfo: {
        real_name: '',           // 真实姓名
        sex: 1,                  // 性别：1-男，0-女
        age: '',                  // 年龄
        school: '',              // 学校
        major: '',               // 专业
        education: '',           // 学历层次：0-未知，1-初中，2-高中，3-大专，4-本科，5-硕士，6-博士
        job_type: '',            // 求职类型：0-社招，1-校招，2-实习
        job_objective: '',       // 期望职位
        desired_city: [],        // 期望城市（多选）
        expected_salary_start: '', // 期望薪资-起
        expected_salary_end: '',   // 期望薪资-止
        mobile: '',              // 手机号
        email: '',               // 邮箱
        avatar: ''               // 头像/证件照
      },
      // 求职类型选项
      jobTypes: JOB_TYPES,
      // 城市选择数据
      hotCities: HOT_CITIES,
      citiesByLetter: CITIES_BY_LETTER,
      defaultAvatar: 'https://ai-interview.obs.cn-southwest-2.myhuaweicloud.com/image/829eb34f-f1fb-4d01-9491-89f37e54efd2.jpg',
      beautifys: [
        {
          img: require('./assets/img/FigmaDDSSlicePNG736f8ec1e6133b8f4523a1668d7002c4.png'),
          name: '不使用',
          clicked: true,
          clickFunc: (index) => {
            this.handleClickDontUse(index, this.beautifys)
            while (this.usingBeautifys.length != 0) { this.usingBeautifys.pop() }
          }
        },
        {
          img: require('./assets/img/FigmaDDSSlicePNG880bfdcb68c76e774a8c3b44e65a1d58.png'),
          name: '磨皮',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickSlidable(index, this.beautifys)
            const item = this.beautifys[index]
            if (this.usingBeautifys.indexOf(item) == -1) this.usingBeautifys.push(item)
          },
          slideValue: 0
        },
        {
          img: require('./assets/img/FigmaDDSSlicePNG45c746f5597e5f0e06b653f5fae19992.png'),
          name: '美白',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickSlidable(index, this.beautifys)
            const item = this.beautifys[index]
            if (this.usingBeautifys.indexOf(item) == -1) this.usingBeautifys.push(item)
          },
          slideValue: 0
        },
        {
          img: require('./assets/img/FigmaDDSSlicePNG12205dc6608df88c4a3dc8e0d7d265a0.png'),
          name: '锐化',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickSlidable(index, this.beautifys)
            const item = this.beautifys[index]
            if (this.usingBeautifys.indexOf(item) == -1) this.usingBeautifys.push(item)
          },
          slideValue: 0
        },
      ],
      usingFilter: null,
      filters: [
        {
          img: require('./assets/img/FigmaDDSSlicePNG736f8ec1e6133b8f4523a1668d7002c4.png'),
          name: '不使用',
          clicked: true,
          clickFunc: (index) => {
            this.handleClickDontUse(index, this.filters)
            this.usingFilter = null
          }
        },
        {
          img: require('./assets/img/388d67c493454b80a7c64cd624d10332_mergeImage.png'),
          name: '标准',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickSlidable(index, this.filters)
            const item = this.filters[index]
            this.usingFilter = item
          },
          slideValue: 0
        },
        {
          img: require('./assets/img/470c0a715c6646a9bd9e4d77d5a170c3_mergeImage.png'),
          name: '樱桃红',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickSlidable(index, this.filters)
            const item = this.filters[index]
            this.usingFilter = item
          },
          slideValue: 0
        },
      ],
      usingBackground: null,
      backgrounds: [
        {
          img: require('./assets/img/FigmaDDSSlicePNG736f8ec1e6133b8f4523a1668d7002c4.png'),
          name: '不使用',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickBackground(index)
            const item = this.backgrounds[index]
            this.usingBackground = item
          }
        },
        {
          img: require('./assets/img/429cc2f57aaf426f869b00a9d52d1eda_mergeImage.png'),
          name: '客厅',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickBackground(index)
            const item = this.backgrounds[index]
            this.usingBackground = item
          }
        },
        {
          img: require('./assets/img/3fa846dc92d447c185029f3e5bcad68e_mergeImage.png'),
          name: '会议室',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickBackground(index)
            const item = this.backgrounds[index]
            this.usingBackground = item
          }
        },
        {
          img: require('./assets/img/654a0df5ce6a4241adceb8ce796b1db7_mergeImage.png'),
          name: '瑜伽室',
          clicked: false,
          clickFunc: (index) => {
            this.handleClickBackground(index)
            const item = this.backgrounds[index]
            this.usingBackground = item
          }
        },
        {
          img: require('./assets/img/5dd8a8d9ff9d4894a5a4caa59b60855f_mergeImage.png'),
          name: '大厅',
          clicked: true,
          clickFunc: (index) => {
            this.handleClickBackground(index)
            const item = this.backgrounds[index]
            this.usingBackground = item
          }
        },
      ],
      safeUserData: {},
      isCompleteUserData: false,
      defaultAvatarUrl: '/adminapi/static/default_avatar.png'
    };
  },
  methods: {
    async startInterview() {
      if (!this.$store.state.interviewState.jd || !this.$store.state.interviewState.cv) {
        this.$message.error('缓存已失效，请尝试重新上传简历')
        return
      }
      if (this.cameraAccess == 'denied') {
        this.$message.error('请打开摄像头进行面试')
        return
      }
      if (this.waitForPrompt) return
      this.waitForPrompt = true
      
      // 每次开始面试前重置上一轮面试的状态，避免二次进入分析页后残留旧数据
      // 只重置 interviewState 模块，其他模块不受影响
      await this.$store.dispatch('interviewState/resetInterviewState')

      // 检查文件是否已上传到对象存储
      if (!this.$store.state.interviewState.jd.url || !this.$store.state.interviewState.cv.url) {
        this.$message.error('请先上传简历和岗位要求文件');
        this.waitForPrompt = false
        return
      }

      // 若未在Dashboard触发，这里兜底触发一次后台生成
      if (!this.prompt && !this.promptLoading) {
        this.$store.dispatch('interviewState/generatePromptInBackground')
      }

      // 轮询等待prompt返回或错误，显示加载动画
      this.waitingForPrompt = true
      try {
        const waitResult = await new Promise((resolve) => {
          const start = Date.now()
          const timeoutMs = 120000
          const interval = setInterval(() => {
            const hasPrompt = !!this.$store.state.interviewState.prompt && !!this.$store.state.interviewState.interviewId
            const hasError = !!this.$store.state.interviewState.promptError
            const expired = Date.now() - start > timeoutMs
            if (hasPrompt || hasError || expired) {
              clearInterval(interval)
              resolve({ hasPrompt, hasError, expired })
            }
          }, 500)
        })

        if (!waitResult.hasPrompt) {
          if (waitResult.hasError) {
            this.$message.error('面试准备失败，请稍后重试')
          } else if (waitResult.expired) {
            this.$message.warning('准备超时，请稍后重试')
          }
          this.waitForPrompt = false
          this.waitingForPrompt = false
          return
        }

        // 准备完成，设置摄像头参数并启动面试
        const interviewState = {
          usingBeautifys: this.usingBeautifys,
          usingFilter: this.usingFilter,
          usingBackground: this.usingBackground
        }
        await this.$store.dispatch('interviewState/setCameraSetting', interviewState)
        await this.$store.dispatch('interviewState/startInterview')

        this.waitForPrompt = false
        this.$router.push('/store/interview_ing')
      } catch (e) {
        console.error('面试启动失败:', e)
        this.$message.error('面试启动失败，请稍后再试')
        this.waitForPrompt = false
      } finally {
        this.waitingForPrompt = false
      }
    },
    setTabClass() {
      const tabs = document.querySelectorAll('.el-tabs__item')
      const leftTab = tabs[0]
      if (this.activeTab == 'beautify') {
        leftTab.classList.remove('middle-active')
        leftTab.classList.remove('right-active')
      } else if (this.activeTab == 'filter') {
        leftTab.classList.add('middle-active')
        leftTab.classList.remove('right-active')
      } else {
        leftTab.classList.remove('middle-active')
        leftTab.classList.add('right-active')
      }
      const middleTab = tabs[1]
      if (this.activeTab == 'beautify') {
        middleTab.classList.add('left-active')
        middleTab.classList.remove('right-active')
      } else if (this.activeTab == 'filter') {
        middleTab.classList.remove('left-active')
        middleTab.classList.remove('right-active')
      } else {
        middleTab.classList.remove('left-active')
        middleTab.classList.add('right-active')
      }
      const rightTab = tabs[2]
      if (this.activeTab == 'beautify') {
        rightTab.classList.add('left-active')
        rightTab.classList.remove('middle-active')
      } else if (this.activeTab == 'filter') {
        rightTab.classList.remove('left-active')
        rightTab.classList.add('middle-active')
      } else {
        rightTab.classList.remove('left-active')
        rightTab.classList.remove('middle-active')
      }
    },
    handleClickBackground(index) {
      for (let i = 0; i < this.backgrounds.length; i++) {
        const item = this.backgrounds[i]
        if (i == index) item.clicked = true
        else item.clicked = false
      }
    },
    handleClickDontUse(index, group) {
      for (let i = 0; i < group.length; i++) {
        const item = group[i]
        if (i == index) item.clicked = true
        else {
          item.clicked = false
          item.slideValue = 0
        }
      }
      this.selectSlidable = false
    },
    handleClickSlidable(index, group) {
      for (let i = 0; i < group.length; i++) {
        const item = group[i]
        if (i == index) {
          item.clicked = true
          this.slideItem = item
        }
        else item.clicked = false
      }
      this.selectSlidable = true
    },
    ffmpegStartDownloading() { this.ffmpegDownloading = true },
    ffmpegStopDownloading() { this.ffmpegDownloading = false },
    
    // 等待getGenerateJson接口响应后再打开个人信息弹窗
    waitForGenerateJsonAndOpenModal() {
      // 检查是否已经有数据或正在加载
      if (this.generateJsonData) {
        // 如果已经有数据，直接检查个人信息弹窗
        console.log('getGenerateJson数据已存在，开始检查个人信息弹窗');
        setTimeout(() => {
          this.openPersonalInfoModal();
        }, 500);
        return;
      }

      if (this.generateJsonLoading) {
        // 如果正在加载，等待加载完成
        console.log('getGenerateJson正在加载中，等待完成...');
        this.waitForLoadingComplete();
        return;
      }

      // 如果既没有数据也没有在加载，可能接口还没开始调用，等待一段时间后重试
      console.log('getGenerateJson接口可能还未开始调用，等待中...');
      setTimeout(() => {
        this.waitForGenerateJsonAndOpenModal();
      }, 1000);
    },

    // 等待加载完成
    waitForLoadingComplete() {
      const checkInterval = setInterval(() => {
        if (!this.generateJsonLoading) {
          clearInterval(checkInterval);
          console.log('getGenerateJson加载完成，开始检查个人信息弹窗');
          // 等待更长时间确保数据已更新
          setTimeout(() => {
            this.openPersonalInfoModal();
          }, 1000);
        }
      }, 500);
    },
    
    // 个人信息弹窗相关方法
    async openPersonalInfoModal() {
      try {
        // 先获取用户信息

          const userData = this.safeUserData;
          console.log("获取用户信息成功:", userData);

          // 检查关键字段是否完整：姓名、年龄、学校、专业、学历层次
          const hasName =
            userData.real_name && userData.real_name.trim() !== "";
          const hasAge = userData.age && userData.age > 0;
          const hasSchool = userData.school && userData.school.trim() !== "";
          const hasMajor = userData.major && userData.major.trim() !== "";
          const hasEducation =
            userData.education &&
            userData.education !== "" &&
            userData.education !== 0; // 0-未知，1-初中，2-高中，3-大专，4-本科，5-硕士，6-博士

          // 如果关键字段缺失（姓名、年龄、学校、专业、学历层次），则打开弹窗
          if (!hasName || !hasAge || !hasSchool || !hasMajor || !hasEducation) {
            console.log("用户信息不完整，打开弹窗。缺失字段:", {
              name: !hasName,
              age: !hasAge,
              school: !hasSchool,
              major: !hasMajor,
              education: !hasEducation,
            });
            this.showPersonalInfoModal = true;
            this.isCompleteUserData = false
            // 先用用户信息填充表单，再用getGenerateJson数据补全
            this.loadUserInfoWithGenerateJsonFallback(userData);
          } else {
            // 个人信息完整，不打开弹窗
            this.showPersonalInfoModal = false;
            this.isCompleteUserData = true
          }
        } catch (error) {
        console.error("检查个人信息时出错:", error);
        // 出错时也打开弹窗
        this.showPersonalInfoModal = true;
        this.isCompleteUserData = false
        this.loadUserInfoWithGenerateJsonFallback();
      }
    },
    closePersonalInfoModal() {
      this.showPersonalInfoModal = false;
    },
    // 先用用户信息填充表单，再用getGenerateJson数据补全缺失字段
    loadUserInfoWithGenerateJsonFallback(userData = null) {
      try {
        // 先填充用户信息数据
        if (userData) {
          console.log("先用用户信息填充表单:", userData);
          this.personalInfo = {
            real_name: userData.real_name || "",
            sex: userData.sex === "男" ? 1 : userData.sex === "女" ? 0 : (userData.sex !== undefined ? userData.sex : 1),
            age: userData.age || "",
            school: userData.school || "",
            major: userData.major || "",
            education: userData.education,
            job_type: userData.job_type !== undefined ? userData.job_type : '',
            job_objective: userData.job_objective || '',
            desired_city: userData.desired_city ? (Array.isArray(userData.desired_city) ? userData.desired_city : userData.desired_city.split(',')) : [],
            expected_salary_start: userData.expected_salary_start || '',
            expected_salary_end: userData.expected_salary_end || '',
            mobile: userData.mobile || '',
            email: userData.email || '',
            avatar: userData.avatar || ''
          };
        } else {
          // 如果没有用户信息，使用默认值
          this.personalInfo = {
            real_name: "",
            sex: 1,
            age: "",
            school: "",
            major: "",
            education: 1,
            avatar: '',
            job_type: '',
            job_objective: '',
            desired_city: [],
            expected_salary_start: '',
            expected_salary_end: '',
            mobile: '',
            email: ''
          };
        }

        // 再用getGenerateJson数据补全缺失的字段
        const generateJsonData = this.generateJsonData;
        if (generateJsonData) {
          console.log("用getGenerateJson数据补全缺失字段:", generateJsonData);
          
          // 只补全空值或无效值的字段
          if (!this.personalInfo.real_name && generateJsonData.real_name) {
            this.personalInfo.real_name = generateJsonData.real_name;
          }
          if (!this.personalInfo.age && generateJsonData.age) {
            this.personalInfo.age = generateJsonData.age;
          }
          if (!this.personalInfo.school && generateJsonData.school) {
            this.personalInfo.school = generateJsonData.school;
          }
          if (!this.personalInfo.major && generateJsonData.major) {
            this.personalInfo.major = generateJsonData.major;
          }
          if ((!this.personalInfo.education || this.personalInfo.education === 0) && generateJsonData.education) {
            this.personalInfo.education = generateJsonData.education;
          }
          if (this.personalInfo.sex === undefined && generateJsonData.sex !== undefined && (generateJsonData.sex == 0 || generateJsonData.sex == 1)) {
            this.personalInfo.sex = generateJsonData.sex;
          }
          if (!this.personalInfo.job_type && generateJsonData.job_type !== undefined) {
            this.personalInfo.job_type = generateJsonData.job_type;
          }
          if (!this.personalInfo.job_objective && generateJsonData.job_objective) {
            this.personalInfo.job_objective = generateJsonData.job_objective;
          }
          if ((!this.personalInfo.desired_city || this.personalInfo.desired_city.length === 0) && generateJsonData.desired_city) {
            this.personalInfo.desired_city = Array.isArray(generateJsonData.desired_city) 
              ? generateJsonData.desired_city 
              : generateJsonData.desired_city.split(',');
          }
          if (!this.personalInfo.expected_salary_start && generateJsonData.expected_salary_start) {
            this.personalInfo.expected_salary_start = generateJsonData.expected_salary_start;
          }
          if (!this.personalInfo.expected_salary_end && generateJsonData.expected_salary_end) {
            this.personalInfo.expected_salary_end = generateJsonData.expected_salary_end;
          }
          if (!this.personalInfo.mobile && generateJsonData.mobile) {
            this.personalInfo.mobile = generateJsonData.mobile;
          }
          if (!this.personalInfo.email && generateJsonData.email) {
            this.personalInfo.email = generateJsonData.email;
          }
          if (!this.personalInfo.avatar && generateJsonData.avatar) {
            this.personalInfo.avatar = generateJsonData.avatar;
          }
        }

        console.log('最终填充的表单数据:', this.personalInfo);
      } catch (error) {
        console.error("填充表单数据失败:", error);
        this.$message.error("数据加载失败，请重试");
      }
    },
    // 从getGenerateJson数据加载用户信息并填充表单
    loadUserInfoFromGenerateJson() {
      try {
        const userData = this.generateJsonData;
        console.log("从getGenerateJson数据填充表单:", userData);

        if (userData) {
          // 确保 userData 存在，如果不存在则使用空对象
          const safeUserData = userData || {};

          // 填充表单数据
          this.personalInfo = {
            real_name: safeUserData.real_name || "",
            sex: safeUserData.sex !== undefined ? safeUserData.sex : 1, // 直接使用数字值
            age: safeUserData.age || "",
            school: safeUserData.school || "",
            major: safeUserData.major || "",
            education: safeUserData.education || 1,
            // 新字段
            job_type: safeUserData.job_type !== undefined ? safeUserData.job_type : '',
            job_objective: safeUserData.job_objective || '',
            desired_city: safeUserData.desired_city ? (Array.isArray(safeUserData.desired_city) ? safeUserData.desired_city : safeUserData.desired_city.split(',')) : [],
            expected_salary_start: safeUserData.expected_salary_start || '',
            expected_salary_end: safeUserData.expected_salary_end || '',
            mobile: safeUserData.mobile || '',
            email: safeUserData.email || '',
            avatar: safeUserData.avatar || ''
          };
          
          console.log('从getGenerateJson填充后的表单数据:', this.personalInfo);
        } else {
          console.log("没有getGenerateJson数据，使用默认值");
          // 使用默认值
          this.personalInfo = {
            real_name: "",
            sex: 1,
            age: "",
            school: "",
            major: "",
            education: 1,
            avatar: '',
            job_type: '',
            job_objective: '',
            desired_city: [],
            expected_salary_start: '',
            expected_salary_end: '',
            mobile: '',
            email: ''
          };
        }
      } catch (error) {
        console.error("从getGenerateJson数据填充表单失败:", error);
        this.$message.error("数据加载失败，请重试");
      }
    },
    // 加载用户信息并填充表单（保留原方法作为备用）
    async loadUserInfo() {
      try {
        const response = await getUserInfo();
        console.log("获取用户信息响应:", response);

        if (response.data.code == 1) {
          const userData = response.data.data;
          console.log("用户信息:", userData);

          // 确保 userData 存在，如果不存在则使用空对象
          const safeUserData = userData || {};

          // 填充表单数据
          this.personalInfo = {
            real_name: safeUserData.real_name || "",
            sex: safeUserData.sex === "男" ? 1 : safeUserData.sex === "女" ? 0 : 1, // 转换为数字
            age: safeUserData.age || "",
            school: safeUserData.school || "",
            major: safeUserData.major || "",
            education: safeUserData.education || 1, // 使用education字段
            // 新字段
            job_type: safeUserData.job_type || '',
            job_objective: safeUserData.job_objective || '',
            desired_city: safeUserData.desired_city ? (Array.isArray(safeUserData.desired_city) ? safeUserData.desired_city : safeUserData.desired_city.split(',')) : [],
            expected_salary_start: safeUserData.expected_salary_start || '',
            expected_salary_end: safeUserData.expected_salary_end || '',
            mobile: safeUserData.mobile || '',
            email: safeUserData.email || '',
            avatar: safeUserData.avatar || ''
          };
          
          console.log('填充后的表单数据:', this.personalInfo);
        } else {
          console.log("获取用户信息失败:", response);
        }
      } catch (error) {
        console.error("获取用户信息失败:", error);
        this.$message.error("获取用户信息失败，请重试");
      }
    },
    clearPersonalInfoForm() {
      this.personalInfo = {
        real_name: "",
        sex: 1,
        age: "",
        school: "",
        major: "",
        education: 1,
        avatar: '',
        job_type: '',
        job_objective: '',
        desired_city: [],
        expected_salary_start: '',
        expected_salary_end: '',
        mobile: '',
        email: ''
      };
    },
    submitPersonalInfo() {
      // 验证必填字段（对象形式：字段名 => 显示标签）
      const requiredFields = {
        real_name: '真实姓名',
        school: '学校',
        major: '专业',
        mobile: '手机号',
        email: '邮箱',
        job_objective: '求职意向',
        desired_city: '期望城市',
        expected_salary_start: '期望薪资起始',
        expected_salary_end: '期望薪资结束',
        avatar: '头像'
      };
      
      const missingFields = Object.keys(requiredFields).filter(field => {
        if (field === 'desired_city') {
          return !this.personalInfo[field] || this.personalInfo[field].length === 0;
        }
        return !this.personalInfo[field];
      }).map(field => requiredFields[field]);
      
      // 单独验证job_type（因为0是有效值）
      if (this.personalInfo.job_type === '' || this.personalInfo.job_type === null || this.personalInfo.job_type === undefined) {
        missingFields.push('求职类型');
      }
      
      // 单独验证数字类型字段
      if (!this.personalInfo.age || this.personalInfo.age === 0) {
        missingFields.push("年龄");
      }

      if (this.personalInfo.sex != 0 && this.personalInfo.sex != 1) {
        missingFields.push("性别");
      }

      if (missingFields.length > 0) {
        console.log("缺少的必填字段:", missingFields);
        console.log("当前表单数据:", this.personalInfo);
        this.$message.warning(
          `请填写所有必填字段: ${missingFields.join(", ")}`
        );
        return;
      }

      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.personalInfo.mobile)) {
        this.$message.warning("请输入正确的手机号码");
        return;
      }

      // 验证邮箱格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.personalInfo.email)) {
        this.$message.warning("请输入正确的邮箱地址");
        return;
      }

      // 验证年龄
      const age = parseInt(this.personalInfo.age);
      if (isNaN(age) || age < 16 || age > 100) {
        this.$message.warning("请输入正确的年龄（16-100岁）");
        return;
      }
      
      // 调用API保存个人信息
      this.savePersonalInfo();
    },
    // 证件照上传相关方法
    triggerPhotoUpload() {
      this.$refs.photoInput.click();
    },
    async handlePhotoUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型
      if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
        this.$message.error("请上传JPG或PNG格式的图片");
        return;
      }

      // 验证文件大小（2MB）
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("图片大小不能超过2MB");
        return;
      }

      try {
        // 显示上传中状态
        this.$message.info("正在上传证件照...");

        // 构造符合lxUploadFile接口要求的文件对象
        const fileObj = {
          file: file,
        };

        // 调用lxUploadFile接口上传文件
        const response = await lxUploadFile(fileObj);
        console.log("上传响应数据:", response);

        if (
          response &&
          response.data.code === 1 &&
          response.data.data &&
          response.data.data.url
        ) {
          // 上传成功，保存URL
          const originalUrl = response.data.data.url;
          console.log("原始URL:", originalUrl);
          console.log("URL类型:", typeof originalUrl);
          console.log("URL长度:", originalUrl.length);

          this.personalInfo.avatar = originalUrl;
          console.log("保存的avatar URL:", this.personalInfo.avatar);
          console.log("保存后的URL类型:", typeof this.personalInfo.avatar);

          this.$message.success("证件照上传成功");
        } else {
          console.log("上传失败，响应数据:", response);
          this.$message.error(
            response?.data?.msg || response?.msg || "证件照上传失败，请重试"
          );
        }
      } catch (error) {
        console.error("证件照上传失败:", error);
        this.$message.error("网络错误，请检查网络连接后重试");
      }
    },
    removePhoto() {
      this.personalInfo.avatar = "";
      this.$refs.photoInput.value = "";
      this.$message.success("证件照已删除");
    },
    // 保存个人信息到服务器
    async savePersonalInfo() {
      try {      
        const isDefault = this.personalInfo.avatar === '/adminapi/static/default_avatar.png'
        // 准备提交的数据
        const submitData = {
          real_name: this.personalInfo.real_name,
          sex: this.personalInfo.sex,
          age: parseInt(this.personalInfo.age),
          school: this.personalInfo.school,
          major: this.personalInfo.major,
          education: this.personalInfo.education,
          job_type: this.personalInfo.job_type, // Integer类型，0为社招，1为校招，2为实习
          job_objective: this.personalInfo.job_objective, // String类型，期望职位
          desired_city: Array.isArray(this.personalInfo.desired_city) ? this.personalInfo.desired_city.join(',') : '', // String类型，多个城市使用逗号隔开
          expected_salary_start: this.personalInfo.expected_salary_start, // String类型，期望薪资-起
          expected_salary_end: this.personalInfo.expected_salary_end, // String类型，期望薪资-止
          mobile: this.personalInfo.mobile,
          email: this.personalInfo.email,
          avatar: isDefault ? this.defaultAvatar : this.personalInfo.avatar,
        };

        // 调用setInfo接口
        const response = await setInfo(submitData);

        if (response && response.data.code === 1) {
          this.$message.success("个人信息保存成功！");
          this.closePersonalInfoModal();
        } else {
          this.$message.error(
            response?.data?.msg || "个人信息保存失败，请重试"
          );
        }
      } catch (error) {
        console.error("保存个人信息失败:", error);
        this.$message.error("网络错误，请检查网络连接后重试");
      }
    },
    // 城市选择变化处理
    handleCityChange(value) {
      // 若选择了"全国"，则只保留"全国"
      if (Array.isArray(this.personalInfo.desired_city)) {
        const hasAll = this.personalInfo.desired_city.includes('全国');
        if (hasAll && this.personalInfo.desired_city.length > 1) {
          this.personalInfo.desired_city = ['全国'];
        }
      }
    },
    // 获取头像URL的计算属性
    getAvatarUrl() {
      if (this.personalInfo && this.personalInfo.avatar) {
        const isDefault = this.personalInfo.avatar === this.defaultAvatarUrl || !this.personalInfo.avatar.includes('https')
        return isDefault ? this.defaultAvatar : this.personalInfo.avatar;
      }
      // 如果没有头像，返回默认头像
      return this.defaultAvatar;
    }
  },
  beforeDestroy() {
    // 在页面销毁前释放摄像头资源
    if (this.$refs.vertcVideo) {
      this.$refs.vertcVideo.releaseResources();
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-slider__button-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

::v-deep .el-slider__runway {
  background: rgba(192, 192, 192, 1);
}

::v-deep .el-slider__bar {
  background: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  height: 405px;
  border: solid 3px rgba(177, 110, 249, 1);
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: linear-gradient(0deg,
      rgba(238, 238, 238, 1) 0,
      transparent 100%);
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__item {
  width: 33.53%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  background: none;
  border-bottom: none !important;
  border-top: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 4px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).middle-active {
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).right-active {
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  background: none;
  border-bottom: none !important;
  border-top: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 50%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(2).left-active {
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(2).right-active {
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(3).is-active {
  width: 34.1%;
  background: none;
  border-bottom: none !important;
  border-top: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-right: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(3).left-active {
  width: 34.1%;
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 0px;
  margin-left: -3px !important;
}

::v-deep .el-tabs__item:nth-child(3).middle-active {
  width: 34.1%;
  background: none;
  border-bottom: solid rgba(177, 110, 249, 1) 3px !important;
  border-left: solid rgba(177, 110, 249, 1) 3px !important;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: -3px !important;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
}

/* @media (max-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.67);
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: center center;
    transform: scale(0.87);
  }
} */

.scaler {
  transform-origin: top left;
  transform: scale(0.67);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page {
  background: url(./assets/img/FigmaDDSSlicePNG89def777d99a3bb366c5d59c29791444_clip.png) no-repeat center center;
  background-size: 100vw 100vh;
}

.grid-container {
  display: grid;
  /* grid-template-columns: 1fr 1fr 1fr 1fr; */
  grid-template-columns: repeat(var(--grid-columns), 1fr);
  column-gap: 0px;
  row-gap: 10px;
  margin-top: 20px;
  margin-left: 40px;
}

.grid-item {
  box-shadow: 0px 0px 0px 1px rgba(126, 180, 235, 1);
  border-radius: 24px;
  width: 80px;
  height: 80px;
}

.clicked {
  box-shadow: inset 3px 0px 3px 5px rgba(0, 0, 0, 0.3);
}

.sliderLine {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  bottom: 50px;
}

.spinner {
  border: 5px solid rgba(126, 180, 235, 1);
  border-radius: 50%;
  border-top: 5px solid rgba(177, 110, 249, 1);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 自定义弹窗样式 */
.custom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  width: 90%;
}

.popup-image {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
  border-radius: 10px;
}

.popup-text {
  color: #333;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
}

/* 个人信息填写弹窗样式 */
.personal-info-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.personal-info-modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  transition: all 0.3s;
}

.personal-info-modal-content {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  width: 94%;
  max-width: 920px;
  max-height: 90vh;
  position: relative;
  z-index: 1;
  animation: personalInfoModalFadeIn 0.3s;
  display: flex;
  flex-direction: column;
}

@keyframes personalInfoModalFadeIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.personal-info-header {
  background: linear-gradient(90deg, #4a90e2 0%, #7b68ee 100%);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  font-family: Afacad;
}

.personal-info-close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.personal-info-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.personal-info-close-btn i {
  color: #ffffff;
  font-size: 14px;
}

.personal-info-form {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 0;
}

.form-row {
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: flex-start;
}

.form-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  min-width: 0;
}

.form-label {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  font-family: Afacad;
}

.required {
  color: #ff4757;
  margin-left: 2px;
}

.form-input {
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: Afacad;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  height: 40px;
}

.form-input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.form-input::placeholder {
  color: #999999;
}

.form-select {
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: Afacad;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.3s, box-shadow 0.3s;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 40px;
}

.form-select:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

/* 新增：行内紧凑布局与分隔符 */
.row-compact {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 8px;
  align-items: center;
}


.el-select-flex {
  width: 100%;
}

.dash {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #656587;
  width: auto;
  min-width: 16px;
  height: 40px;
  font-size: 16px;
  font-weight: bold;
}

.form-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px 24px;
  flex-shrink: 0;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
}

.btn-clear {
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  font-family: Afacad;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-clear:hover {
  background: #e9ecef;
  border-color: #d0d0d0;
}

.btn-submit {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #4a90e2 0%, #7b68ee 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  font-family: Afacad;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

/* 证件照上传样式 */
.photo-upload-container {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}

.photo-upload-area {
  width: 80px;
  height: 120px;
  border: 2px dashed #d0d0d0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.photo-upload-area:hover {
  border-color: #4a90e2;
  background: #f0f8ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #999;
}

.upload-icon {
  width: 28px;
  height: 28px;
  color: #ccc;
}

.upload-icon svg {
  width: 100%;
  height: 100%;
}

.upload-text {
  font-size: 12px;
  color: #666;
}

.photo-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 6px;
}

.photo-preview:hover .photo-overlay {
  opacity: 1;
}

.change-photo-btn,
.remove-photo-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.change-photo-btn {
  background: #4a90e2;
  color: white;
}

.change-photo-btn:hover {
  background: #357abd;
}

.remove-photo-btn {
  background: #ff4757;
  color: white;
}

.remove-photo-btn:hover {
  background: #ff3742;
}

.upload-tips {
  flex: 1;
  padding: 6px 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tips-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
}

.tips-desc {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 城市下拉：强制调整宽度 */
::v-deep .city-dropdown,
::v-deep .el-select-dropdown.city-dropdown,
::v-deep .el-popper.city-dropdown,
::v-deep .el-select-dropdown__wrap,
::v-deep .el-select-dropdown {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  max-height: 400px !important;
  padding: 6px !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* 强制覆盖Element UI的popper样式 */
::v-deep .el-select-dropdown.city-dropdown {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

/* 覆盖Element UI的默认popper样式 */
::v-deep .el-popper.city-dropdown {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

/* 强制覆盖Element UI默认样式 */
::v-deep .city-dropdown .el-select-dropdown__list {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  padding: 0 !important;
  margin: 0 !important;
}

::v-deep .city-dropdown .el-select-dropdown__item {
  flex: 0 0 calc(33.333% - 11px) !important;
  max-width: calc(33.333% - 11px) !important;
  margin: 0 !important;
  padding: 4px 6px !important;
  border-radius: 12px !important;
  background: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  text-align: center !important;
  font-size: 11px !important;
  color: #333 !important;
  min-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}
/* 全国选项 - 严格按照UI实现 */
::v-deep .city-dropdown .el-select-dropdown__item:first-child {
  width: 100% !important;
  margin-bottom: 16px !important;
  padding: 10px 12px !important;
  border-radius: 8px !important;
  background: #fff2e8 !important;
  border: 1px solid #ff9500 !important;
  text-align: center !important;
  font-weight: 500 !important;
  color: #ff9500 !important;
  display: block !important;
  font-size: 14px !important;
}

::v-deep .city-dropdown .el-select-dropdown__item:first-child:hover {
  background: #e6f7ff !important;
  border-color: #4a90e2 !important;
  color: #4a90e2 !important;
}

/* 分组标题样式 - 严格按照UI实现 */
::v-deep .city-dropdown .el-select-group__title {
  padding: 8px 0 8px 0 !important;
  margin: 0 0 12px 0 !important;
  color: #333 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  background: transparent !important;
  border: none !important;
  text-align: left !important;
}

/* 分组内容容器 */
::v-deep .city-dropdown .el-select-group__wrap {
  padding: 0 !important;
  margin-bottom: 16px !important;
}

/* 城市列表 - 横向三列网格 */
::v-deep .city-dropdown .el-select-group__wrap .el-select-dropdown__list {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0px !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* 城市按钮样式 - 调整宽度 */
::v-deep .city-dropdown .el-select-group__wrap .el-select-dropdown__item {
  padding: 3px 4px !important;
  margin: 3px !important;
  border-radius: 6px !important;
  background: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  text-align: center !important;
  font-size: 11px !important;
  color: #333 !important;
  transition: all 0.2s !important;
  min-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  flex: 0 0 calc(33.333% - 6px) !important;
  max-width: calc(33.333% - 6px) !important;
}

::v-deep .city-dropdown .el-select-group__wrap .el-select-dropdown__item:hover {
  background: #e6f7ff !important;
  border-color: #4a90e2 !important;
  color: #4a90e2 !important;
}

::v-deep .city-dropdown .el-select-group__wrap .el-select-dropdown__item.selected {
  background: #4a90e2 !important;
  border-color: #4a90e2 !important;
  color: white !important;
}

/* 响应式设计 - 小屏幕适配 */
@media (max-height: 800px) {
  .personal-info-modal-content {
    max-height: 85vh;
  }

  .personal-info-form {
    padding: 20px;
  }

  .form-row {
    gap: 20px;
  }

  .form-column {
    gap: 14px;
  }

  .form-item {
    gap: 5px;
  }

  .form-input,
  .form-select {
    padding: 8px 10px;
    font-size: 13px;
    height: 36px;
  }

  .form-label {
    font-size: 13px;
  }

  .form-buttons {
    padding: 16px 20px;
  }

  .btn-clear,
  .btn-submit {
    padding: 8px 16px;
    font-size: 13px;
  }
}

/* 响应式设计 - 超小屏幕适配 */
@media (max-height: 700px) {
  .personal-info-modal-content {
    max-height: 90vh;
  }

  .personal-info-form {
    padding: 16px;
  }

  .form-row {
    gap: 16px;
  }

  .form-column {
    gap: 12px;
  }

  .form-item {
    gap: 4px;
  }

  .form-input,
  .form-select {
    padding: 6px 8px;
    font-size: 12px;
    height: 32px;
  }

  .form-label {
    font-size: 12px;
  }

  .form-buttons {
    padding: 12px 16px;
  }

  .btn-clear,
  .btn-submit {
    padding: 6px 12px;
    font-size: 12px;
  }
}

/* getGenerateJson数据显示样式 */
.generate-json-display {
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.generate-json-display h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}

.json-content {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  max-height: 300px;
  overflow-y: auto;
}

.json-content pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.4;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* 加载状态样式 */
.loading-display {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #4a90e2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-display span {
  color: #666;
  font-size: 14px;
}

/* 上传占位符文本样式 */
.upload-placeholder-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f5f5f5;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.upload-placeholder-text:hover {
  background-color: #f0f0f0;
  border-color: #B16EF9;
}

.upload-placeholder-text span {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.upload-placeholder-text:hover span {
  color: #B16EF9;
}

</style>